import { Navigate } from 'react-router-dom';
import { useAuth } from '../services/authContext';
import LoginPage from '../pages/LoginPage';

const LoginRedirect = () => {
  const { isAuthenticated, isLoading, user } = useAuth();

  if (isLoading) {
    return null;
  }

  if (isAuthenticated && user) {
    if (user.role === 'operatore') {
      return <Navigate to="/areaOperatori" />;
    } else if (user.role === 'educatore') {
      return <Navigate to="/areaEducatori" />;
    } else {
      return <Navigate to="/areaDirettore" />;
    }
  }

  return <LoginPage />;
};

export default LoginRedirect;